import React from "react";
import { useSelector } from "react-redux";

export default function CongraContentSection() {
  const reward = useSelector((state) => state.user?.reward);

  const images = {
    cap: "/cap.png",
    shirt: "/shirt.png",
    pad: "/pad.png",
    airtime1k: "/airtime1k.png",
    mystery: "/mystery.png",
    sub3: "/subscrption.png",
    airtime5k: "/airtime5k.png",
  };
  const image = images[reward?.rewardWon];

  return (
    <section className="w-full py-10 flex flex-col items-center text-center">
      {/* Heading */}
      <h2 className="text-2xl font-extrabold">Congratulations!</h2>

      {/* Prize image */}
      <div className="mt-6 w-full max-w-xs">
        <img
          src={image}
          alt="Prize"
          className="w-full h-auto rounded-t-xl object-contain"
        />
      </div>

      {/* Reward code */}
      <div className="mt-6">
        <p className="text-2xl font-bold tracking-wide">
          #{reward?.rewardCode}
        </p>
        <p className="mt-2 text-gray-600 text-sm max-w-xs">
          Present your reward code to our representative to collect your prize.
        </p>
      </div>

      {/* Button */}
      <a
        href="https://intraverse.africa"
        target="_blank"
        rel="noopener noreferrer"
        className="w-full max-w-xs mt-8"
      >
        <button
          type="button"
          className="w-full rounded-md py-3 text-white font-semibold
                     bg-gradient-to-r from-blue-500 to-blue-600 shadow-sm active:scale-[.99]"
        >
          Learn More About Intraverse
        </button>
      </a>
    </section>
  );
}
